import React, { lazy, memo } from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { Controller, useFormContext, useWatch } from "react-hook-form";
// import InputField from "Components/formControls/HookFields/InputField";
import { Box } from "@material-ui/core";
import { useOrganizationValidation } from "Validations/Organization/useOrganizationValidation";
const InputField = lazy(() =>
  import("Components/formControls/HookFields/InputField")
);

const Description = ({ name, showLabel, data, addTags, index }) => {
  const { t } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();
  const { strengthDescriptionError } = useOrganizationValidation();
  const nameUpdated =
    index >= 0 ? `${name}.${index}` : `${name}`;

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      addTags?.();
    }
  };
  return (
    <Box flex="1" className="strength-desc">
      <Controller
        register={register(`${nameUpdated}.description`, strengthDescriptionError)}
        name={`${nameUpdated}.description`}
        control={control}
        render={({ field }) => {
          const { onChange } = field;
          return (
            <InputField
              multiline
              label={showLabel ? "Description" : null}
              placeholder={"Type to describe..."}
              error={get(errors, `${nameUpdated}.description.message`, "")}
              value={data?.description || ""}
              onChange={(e) => onChange(e.target.value.trimLeft())}
              onKeyDown={handleKeyDown}
              onBlur={() => setValue(`${nameUpdated}.action`, "upsert")}
            />
          );
        }}
      />
    </Box>
  );
};

export default memo(Description);
